module.exports = __webpack_public_path__ + "img/pagseguro.cc6a982c.png";